export default __webpack_public_path__ + "images/L9.89b6b9a.png";